import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const ScrollAnimation = ({ children, animation = "fade-up", duration = 1000, delay = 0, easing = "ease-in-out" }) => {
  useEffect(() => {
    AOS.init({
      duration,
      easing,
      once: false,  // A animação ocorre apenas uma vez
    });
  }, [duration, easing]);

  return (
    <div data-aos={animation} data-aos-delay={delay}>
      {children}
    </div>
  );
};

export default ScrollAnimation;